document.addEventListener('DOMContentLoaded', () => {
  const blogContainer = document.querySelector('.row__blog');
  const articles = Array.from(document.querySelectorAll('.blog__listing--horizontal'));
  const pills = Array.from(document.querySelectorAll('.blog-tag-pill'));

  // Stop if the blog section is missing.
  if (!blogContainer || !articles.length) {
    return;
  }

  const messageEl = document.getElementById('noTagResultsMessage');
  const searchMessageEl = document.getElementById('noResultsMessage');
  const searchQuerySpan = document.getElementById('searchQueryText');
  const selectedTagTextEl = document.getElementById('selectedTagText');
  const blogSearchForm = document.getElementById('blogSearchForm');
  const blogSearchInput = document.getElementById('blogSearchInput');
  const sortSelect = document.querySelector('.sort-select');
  const searchButton = document.querySelector('.blog-search button');
  const searchInput = document.querySelector('.blog-search input');

  // Remember the selected tag and the latest search text.
  const state = {
    tagId: 'tag-all',
    get query() {
      return (blogSearchInput?.value || '').trim();
    }
  };

  //Helper functions so we don't repeat the same checks.
  const setDisplay = (el, value) => {
    if (el) {
      el.style.display = value ? 'block' : 'none';
    }
  };

  const setText = (el, value) => {
    if (el) {
      el.textContent = value;
    }
  };

  const readArticleTags = (article) => {
    const raw = (article.dataset.tags || '').trim();
    return raw ? raw.split(/\s+/) : [];
  };

  // Hide both “no results” messages.
  const hideMessages = () => {
    setDisplay(messageEl, false);
    setDisplay(searchMessageEl, false);
    setText(searchQuerySpan, '');
  };

  // Show or hide each article based on the tag and search.
  const filterArticles = () => {
    const query = state.query.toLowerCase();
    let hasVisibleArticle = false;

    articles.forEach((article) => {
      const tags = readArticleTags(article);
      const title = article.querySelector('.blog__listing--title')?.textContent.toLowerCase() || '';
      const content = article.querySelector('.blog__listing--content')?.textContent.toLowerCase() || '';
      const matchesTag = state.tagId === 'tag-all' || tags.includes(state.tagId);
      const matchesQuery = !query || title.includes(query) || content.includes(query);

      if (matchesTag && matchesQuery) {
        article.classList.remove('hidden');
        hasVisibleArticle = true;
      } else {
        article.classList.add('hidden');
      }
    });

    if (hasVisibleArticle) {
      hideMessages();
      return;
    }

    if (state.query) {
      setDisplay(searchMessageEl, true);
      setDisplay(messageEl, false);
      setText(searchQuerySpan, `'${state.query}'`);
    } else if (state.tagId !== 'tag-all') {
      const activePill = document.getElementById(state.tagId);
      setDisplay(messageEl, true);
      setDisplay(searchMessageEl, false);
      setText(selectedTagTextEl, activePill ? `'${activePill.textContent.trim()}'` : '');
    } else {
      hideMessages();
    }
  };

  const runFilter = () => filterArticles();

  // When a tag is clicked, mark it active and filter.
  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pills.forEach((item) => item.classList.toggle('active', item === pill));
      state.tagId = pill.id || 'tag-all';
      if (selectedTagTextEl) {
        setText(selectedTagTextEl, `'${pill.textContent.trim()}'`);
      }
      runFilter();
    });
  });

  if (blogSearchForm && blogSearchInput) {
    // Run the filter when someone searches.
    blogSearchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      runFilter();
    });

    blogSearchInput.addEventListener('blur', runFilter);
    blogSearchInput.addEventListener('input', () => {
      if (!state.query) {
        runFilter();
      }
    });
  }

  if (sortSelect) {
    // Reorder articles when the dropdown changes.
    sortSelect.addEventListener('change', () => {
      const { value } = sortSelect;
      const sortedArticles = Array.from(blogContainer.querySelectorAll('.blog__listing--horizontal'));

      sortedArticles.sort((a, b) => {
        if (value === 'latest' || value === 'oldest') {
          const dateA = new Date(a.getAttribute('data-date'));
          const dateB = new Date(b.getAttribute('data-date'));
          return value === 'latest' ? dateB - dateA : dateA - dateB;
        }

        if (value === 'a-z' || value === 'z-a') {
          const titleA = a.querySelector('.blog__listing--title')?.textContent?.trim().toLowerCase() || '';
          const titleB = b.querySelector('.blog__listing--title')?.textContent?.trim().toLowerCase() || '';
          return value === 'a-z' ? titleA.localeCompare(titleB) : titleB.localeCompare(titleA);
        }

        return 0;
      });

      sortedArticles.forEach((article) => blogContainer.appendChild(article));
    });
  }

  if (searchButton && searchInput) {
    // On phones, show the search box without leaving the page.
    searchButton.addEventListener('click', (event) => {
      if (window.innerWidth <= 650) {
        event.preventDefault();
        searchInput.classList.toggle('show-input');
        if (searchInput.classList.contains('show-input')) {
          searchInput.focus();
        }
      }
    });
  }

  // Run once so the page starts in sync.
  runFilter();
});
